import {
    CardActionArea,
    CircularProgress,
    ClickAwayListener,
    Divider,
    Icon,
    Modal, styled,
    SwipeableDrawer, tableRowClasses
} from "@mui/material";
import getLPTheme from '../getLPTheme';
import BottomNavigation from '@mui/material/BottomNavigation';
import Puller from './Puller';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ReorderIcon from '@mui/icons-material/Reorder';
import MapIcon from '@mui/icons-material/Map';
import SpaIcon from '@mui/icons-material/Spa';
import FilterListIcon from '@mui/icons-material/FilterList';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TableCell from '@mui/material/TableCell';
import { useMediaQuery } from "@mui/material";
import FilterIcon from '../images/filter_icon';
import { useTheme } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import PlaceIcon from '@mui/icons-material/Place';
// import CalendarIcon from '@mui/icons-material/CalendarIcon';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ClearIcon from '@mui/icons-material/Clear';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import Chip from '@mui/material/Chip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import {useContext, useEffect, useState, useRef} from 'react';
import {SvgIcon} from "@mui/material";

import {AuthContext} from "../index";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import {compareDesc} from "date-fns";
import Container from "@mui/material/Container";

import { LOCATIONS } from '../data/database';
import {LocalizationProvider, StaticDatePicker} from "@mui/x-date-pickers";
import {grey} from "@mui/material/colors";

import './AppScreen.css';
import {LocalHospital} from "@mui/icons-material";
import LocationsList from './LocationsList';
import Info from './Info';
import { BIMAGES } from '../data/database';
import {createTheme, ThemeProvider} from "@mui/material/styles";

const ItemsList = ({
                       items, itemDetailedPassed=null, pickedItem, handleItemPick, getItemImages, getItemTitle, getItemDescription, getItemId,
        getDetailedComponent, getShortComponent, getItemScrollPosition = () => null, sx = {}, getCardSx = () => ({})
    }) => {
    const [ itemDetailed, setItemDetailed ] = useState(itemDetailedPassed);

    useEffect(() => {
        if (getItemScrollPosition() && getItemScrollPosition().current && typeof getItemScrollPosition().current.scrollIntoView == 'function') {
            getItemScrollPosition()?.current?.scrollIntoView({ behavior: 'smooth'});
        }
    }, [itemDetailedPassed]);

    useEffect(() => {
        setItemDetailed(itemDetailedPassed);
    }, [itemDetailedPassed]);

    return (
        <Stack spacing={2} sx={{m: 1, mt: sx.mt ? sx.mt : ''}}>
            {

                itemDetailed ?
                <Modal
                    open={itemDetailed}
                    sx={{overflow: 'auto', height: '100vh', zIndex: 1305}}
                >
                    <Card
                        elevation={1}
                        sx={{display: 'block', minHeight: '100vh'}}
                        onBlur={() => {}}
                        onClick={() => {}}
                        // sx={{height: '200px'}}
                    >
                        <Box
                            sx={{position: 'relative'}}
                        >
                            {
                                getItemImages(itemDetailed) ?
                                    <CardMedia
                                        sx={{ height: '200px'}}
                                        component="img"
                                        image={ getItemImages(itemDetailed) }
                                        alt=""
                                    /> : null
                            }
                            <Icon
                                onClick={() => { setItemDetailed(null)}}
                                sx={{
                                    '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                                    p: "3px",
                                    backgroundColor: "#eee",
                                    borderRadius: '8px',
                                    position: 'absolute', top: '10px', right: '10px'}}
                            >
                                <ClearIcon/>
                            </Icon>
                        </Box>
                        <CardContent>
                            <Typography align='left' sx={{pb: 2, fontSize: '18px'}}>
                                {
                                    getItemTitle(itemDetailed)
                                }
                            </Typography>
                            <Typography sx={{fontSize: '12px'}} align='left'>
                                {
                                    getItemDescription(itemDetailed)
                                }
                            </Typography>

                            { getDetailedComponent(itemDetailed) }

                            {/*<Stack direction={'row'} sx={{ pt: 2}}>*/}
                            {/*    {*/}
                            {/*        getItemId(itemDetailed) != getItemId(pickedItem) ?*/}
                            {/*            <Chip label={'Выбрать'} size={'small'}*/}
                            {/*                  sx={{p: 1}}*/}
                            {/*                  onClick={(event) => {*/}
                            {/*                      event.stopPropagation();*/}
                            {/*                      handleItemPick(itemDetailed);*/}
                            {/*                  }}*/}
                            {/*            ></Chip> :*/}
                            {/*            <Chip label={'Выбран'} size={'small'}*/}
                            {/*                  sx={{backgroundColor: '#2999ff', p: 1}}*/}
                            {/*                  onClick={(event) => {*/}
                            {/*                      event.stopPropagation();*/}
                            {/*                      handleItemPick(null);*/}
                            {/*                  }}*/}
                            {/*            ></Chip>*/}
                            {/*    }*/}
                            {/*</Stack>*/}
                        </CardContent>
                    </Card>
                </Modal>:
                    items.map(item => {
                        return (
                            <Card
                                elevation={1}
                                sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'},
                                    '&:focus': {outline: 'none'},
                                    border: getItemId(item) == getItemId(pickedItem) ? '1px solid #2999ff' : null,
                                    ...getCardSx()
                                }}
                                onClick={() => setItemDetailed(item) }
                            >
                                <CardActionArea
                                    disableRipple
                                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start'}}
                                    onClick={ () => {} }
                                >

                                    {
                                        getItemImages(item) ?
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 100, height: 100, p: 1, borderRadius: '15px'}}
                                                image={ getItemImages(item) }
                                                alt=""
                                            /> : null
                                    }
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            height: '100%',
                                            width: '100%'
                                        }}
                                    >
                                        <Grid
                                            container
                                            columnSpacing={1}
                                            rowSpacing={1}
                                        >
                                            <Grid item xs={12}>
                                                <Typography sx={{fontSize: '16px'}} align={'left'}>
                                                    {getItemTitle(item)}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        { getShortComponent(item) }
                                        {/*{*/}
                                        {/*    ps.locations[0].times ?*/}
                                        {/*        <Box>*/}
                                        {/*            {*/}
                                        {/*                ps.locations[0].times.map(chip => (*/}
                                        {/*                    <Chip label={chip.label} onClick={ () => {} } ></Chip>*/}
                                        {/*                ))*/}
                                        {/*            }*/}
                                        {/*        </Box>*/}
                                        {/*        : null*/}
                                        {/*}*/}
                                        {/*<Stack direction={'row'}  sx={{pt: 2, justifyContent: 'flex-end'}}>*/}
                                        {/*    {*/}
                                        {/*        ps.serviceTemplate?.id != pickedService.serviceTemplate?.id ?*/}
                                        {/*            <Chip label={'Выбрать'} size={'small'}*/}
                                        {/*                  sx={{p: 1}}*/}
                                        {/*                  onClick={(event) =>{*/}
                                        {/*                      event.stopPropagation();*/}
                                        {/*                      handleServicePick(ps);*/}
                                        {/*                  }}*/}
                                        {/*            ></Chip>*/}
                                        {/*            : <Chip label={'Выбран'} size={'small'}*/}
                                        {/*                  sx={{backgroundColor: '#2999ff', p: 1}}*/}
                                        {/*                  onClick={(event) =>{*/}
                                        {/*                      event.stopPropagation();*/}
                                        {/*                      handleServicePick(null);*/}
                                        {/*                  }}*/}
                                        {/*            ></Chip>*/}
                                        {/*    }*/}
                                        {/*</Stack>*/}
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        );
                    })
            }
        </Stack>
    );
}

export default ItemsList;
